import React from 'react';
import { ShopMenuDropdownProps } from '../interfaces';
import ShopGenderSelector from './ShopGenderSelector';
import ShopTypeLinks from './ShopTypeLinks';
import './ShopMenuDropdown.scss';

const ShopMenuDropdown: React.FC<ShopMenuDropdownProps> = ({
  types,
  shopGender,
  currentGender,
  currentType,
  isProductsPage,
  onGenderChange,
}) => {
  return (
    <div id="shop-catalog-menu" className="submenu-popup header-nav__shop-popup" role="dialog" aria-label="Shop catalog">
      <div className="header-nav__shop-section-label">Shop for</div>
      <ShopGenderSelector value={shopGender} onChange={onGenderChange} />

      <div className="header-nav__shop-section-label header-nav__shop-section-label--spaced">
        Choose type
      </div>
      <ShopTypeLinks
        types={types}
        shopGender={shopGender}
        currentGender={currentGender}
        currentType={currentType}
        isProductsPage={isProductsPage}
      />
    </div>
  );
};

export default ShopMenuDropdown;
